// Pure helpers for the catering menu + recipes import (kitchen flow, go-live).
import { MI } from './menuImportStrings'
import type { MenuImportDish, MenuImportResult } from './menuImportTypes'

/** Import only a clean dry run with at least one dish. */
export function canImportMenu(r: MenuImportResult | null): boolean {
  return Boolean(r && r.dry_run && r.error_dishes === 0 && r.valid_dishes > 0)
}

/** Dishes with problems first, then in file order. */
export function sortDishes(dishes: MenuImportDish[]): MenuImportDish[] {
  return [...dishes].sort((a, b) => Number(b.errors.length > 0) - Number(a.errors.length > 0) || a.first_line - b.first_line)
}

/** What the Result column says for a dish without problems. */
export function dishResultLabel(d: MenuImportDish): string {
  if (d.action === 'create') return MI.create
  return d.keeps_recipe ? MI.keepsRecipe : MI.update(d.replaces_lines)
}

/** "250 g" → per serving, in what was typed (qty ÷ servings made). */
export function perServingTyped(qty: number, unit: string, makes: number): string {
  const v = makes > 0 ? qty / makes : qty
  const r = Math.round(v * 1000) / 1000
  return `${r} ${unit === 'liter' ? 'l' : unit}`
}
